import React, {
  useMemo,
  useState,
  useCallback,
  FC,
}                               from 'react';
import moment                   from 'moment';
import styled                   from 'styled-components';
import { TDataTableRow }        from '@typings/components';
import { IDate }                from '@typings/accountManagement';
import { EAccountPage }         from '@enums/accountManagement';
import { EAppPage }             from '@enums/common';
import { useFetchReportsDates } from '@modules/accountManagement/queries/accountQueries';
import { LinksWrapper }         from '@components/LinksWrapper/LinksWrapper';
import { LinkButton }           from '@components/LinkButton/LinkButton';
import { Loader }               from '@components/Loader/Loader';
import { ReportsPage }          from '@modules/accountManagement/pages/ReportPage';
import { Button }               from '@components/Button/Button';

const Wrapper = styled.div`
  padding: 20px 30px 60px;

  @media (min-width: 1280px) {
    padding: 20px 100px 60px;
  }
`;

const ButtonWrapper = styled.div`
  .MuiButton-root {
    font-size : 14px;
    height    : 30px;
  }
`;

interface IProps {
  push: (path: string) => void;
}

export const ReportsContainer: FC<IProps> = ({ push }) => {
  const [dates, setDates] = useState<IDate[]>([]);

  const { isLoading } = useFetchReportsDates({
    onSuccess: (data: string[]) => {
      const handledDate = data.reduce((acc: IDate[], curr: string) => {
        const date  = moment(curr, 'YYYY/MM/DD');
        const month = +date.format('M');
        const year  = +date.format('YYYY');

        acc.push({ year, month });

        return acc;
      }, []);

      setDates(handledDate);
    },
  });

  const getTableRows = useCallback(
    (allDates: IDate[]): TDataTableRow[] =>
      (allDates ?? []).map(
        (date): TDataTableRow => [{
          value : `${date.year}/${date.month}`,
          align : 'center',
        }, {
          value: (
            <ButtonWrapper>
              <Button
                size    = "medium"
                label   = "Open Report"
                onClick = {() => push(`${EAppPage.AccountManagement}/${date.year}/${EAccountPage.Reports}/${date.month}/report-details`)}
              />
            </ButtonWrapper>
          ),
          align: 'right',
        }],
      ),
    [push],
  );

  const tableRows = useMemo(
    (): TDataTableRow[] => getTableRows(dates),
    [dates, getTableRows],
  );

  return (
    <Wrapper>
      <LinksWrapper>
        <LinkButton
          label   = "Return to Account Management"
          onClick = {(): void => push(`${EAppPage.AccountManagement}/${EAccountPage.Search}`)}
        />
      </LinksWrapper>

      {isLoading
        ? <Loader />
        : <ReportsPage tableRows={tableRows} />}
    </Wrapper>
  );
};
